import React from "react";
import STCreate from "../PureComponents/STCreate";

const RenderSTCreateGeneral = () => {
  return (
    <>
      <STCreate />
    </>
  );
};

export default RenderSTCreateGeneral;
